import axios from 'axios';
import { Toast } from 'vant';
import i18n from '@/i18n';
import store from "../store";
import configs from '@/config/index'
import { LANGUAGE } from '@/common/constants';
// 全局loading状态管理
let loadingInstance = null;
let loadingCount = 0;

// 显示loading
const showLoading = () => {
  if (loadingCount === 0) {
    // 这里根据您使用的UI框架来显示loading，例如使用vant
    // 如果使用vant，可以这样显示：
    loadingInstance = Toast.loading({
      message: i18n.t('loading'),
      forbidClick: true,
      loadingType: 'spinner',
      duration: 0,
      className: 'http-loading'
    });
  }
  loadingCount++;
};

// 隐藏loading
const hideLoading = () => {
  if (loadingCount > 0) {
    loadingCount--;
  }
  if (loadingCount === 0 && loadingInstance) {
    loadingInstance.clear();
  }
};

const API_URL = configs.apiUrl || '/'
const request = axios.create({
  baseURL: API_URL,
  timeout: 15000
})

// request 拦截器
request.interceptors.request.use(config => {
  console.log('request:', config);
  // 默认显示loading，除非显式设置为false
  const showLoadingFlag = config._showLoading !== false;

  if (showLoadingFlag) {
    showLoading();
  }
  let accessToken = store.state?.user?.session?.accessToken || '';
  if (accessToken) {
    config.headers['Authorization'] = `Bearer ${accessToken}`;
  }
  config.headers['Accept-Language'] = i18n.locale || LANGUAGE.en;
  config.headers['Content-Type'] = "application/json";
  // return config
  // reqLogin为空时 默认true,只有传false时才表示不需要校验登录
  if (!accessToken && config._reqLogin !== false) { // 登录失效
    return Promise.reject({
      response: {
        status: 401
      }
    })
  } else {
    return config;
  }

}, error => {
  hideLoading(); // 请求错误时也要隐藏loading
  return Promise.reject(error)
})

// response 拦截器
request.interceptors.response.use(
  (response) => {
    hideLoading(); // 请求成功时隐藏loading
    let res = response.data
    // 如果是返回的文件
    if (response.config.responseType === 'blob') {
      return res
    }
    // 兼容服务端返回的字符串数据
    if (typeof res === 'string') {
      res = res ? JSON.parse(res) : res
    }

    const reqLogin = response.config._reqLogin !== false;
    if (res.code !== 200) {
      // 登录失效
      if (res.code === 401 && reqLogin) {
        throttledGoLogin();
      }
    }
    return res
  },
  error => {
    hideLoading(); // 请求失败时也要隐藏loading
    // 检查是否为登录失效（通常为401状态码）
    const reqLogin = error.config?._reqLogin !== false;
    if (error.response && (error.response.status === 401 || error.response.status === 403) && reqLogin) {
      throttledGoLogin();
      return Promise.reject('');
    }

    return Promise.reject(error)
  }
)

// 节流函数 - 防止重复执行
const throttle = (func, delay) => {
  let lastExecTime = 0;
  return function (...args) {
    const currentTime = Date.now();
    if (currentTime - lastExecTime >= delay) {
      lastExecTime = currentTime;
      func.apply(this, args);
    }
  };
};

// 节流版本的登录跳转方法
const goLogin = async () => {
  // 防止重复执行：检查是否已经有登录跳转操作在执行
  if (window.__isLoginRedirecting) {
    return;
  }

  window.__isLoginRedirecting = true;

  if (store.state?.user?.session?.refreshToken) {
    let logingResult = await store.dispatch('user/refresh');
    if (logingResult.code === "Success") {
      // 刷新成功
      window.location.reload();
      return;
    }
  }
  // 提示登录失效
  Toast({
    message: i18n.t('loginExpired'),
    duration: 2000
  });

  // 跳转到登录页面（根据您的路由配置调整）
  setTimeout(async () => {
    window.__isLoginRedirecting = false;
    await store.dispatch('user/clearLogin');
    // 假设您的登录路由为 /login
    window.location.href = '/login';
  }, 2000);
};

// 使用节流包装的登录跳转方法，防止重复执行
const throttledGoLogin = throttle(goLogin, 3000); // 3秒内只执行一次

const _get = (url, params, config = {}) => {
  return request.get(url, {
    ...config,
    params: params
  });
};

const _post = (url, params, config = {}) => {
  return request.post(url, params, config);
};

const _put = (url, params, config = {}) => {
  return request.put(url, params, config);
};

const _delete = (url, params, config = {}) => {
  return request.delete(url, {
    ...config,
    params: params
  });
};

export default {
  get: _get,
  post: _post,
  put: _put,
  delete: _delete
};
